import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useEffect } from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, FormLabel } from "@mui/material";
import { ModalContainer } from "../../../../../../common/components/modal_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ItensChecklistListaForm, ItensChecklistListaSchema } from "../../../schemas/ChecklistItens_cadastro/Checklist_lista_Itens";
import { ItemChecklistLista } from "../../../../domain/models/ItemChecklistLista";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import FormContainer from "../../../../../../common/components/form_container";
import { isNotNullOrUndefined } from "../../../../../../common/utils/utils";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";


type Props = {
  open: boolean;
  saving: boolean;
  selectedItemChecklist: ItemChecklistLista | undefined;
  onSubmit: (form: ItensChecklistListaForm) => void;
  onClose: () => void;
  onOpenChangeHistory: (id: number, tabelaTipo: LogTipoTabela) => void;
};

export const ModalItensChecklistLista = ({ open, onClose, saving, onSubmit, selectedItemChecklist, onOpenChangeHistory }: Props) => {
  const hookForm = useForm<ItensChecklistListaForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ItensChecklistListaSchema),
  });

  useEffect(() => {
    if (selectedItemChecklist) {
        hookForm.setValue("idChecklist", selectedItemChecklist.IdChecklist);
        hookForm.setValue("idItemchecklist", selectedItemChecklist.IdItemChecklist);
        hookForm.setValue("descricao", selectedItemChecklist.Descricao);
        hookForm.setValue("codigo", selectedItemChecklist.Codigo);
    } else {
      hookForm.reset();
    }
  }, [hookForm, open, selectedItemChecklist]);

  const handleSubmit = useCallback(
    (form: ItensChecklistListaForm) => {
      if (!saving) onSubmit(form);
    },
    [saving, onSubmit]
  );

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  const handleChangeHistory = useCallback(() => {
    if (selectedItemChecklist) {
      onOpenChangeHistory(selectedItemChecklist.IdItemChecklist, LogTipoTabela.ITEM_CHECKLIST);
    }
  }, [selectedItemChecklist, onOpenChangeHistory]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            component: "form",
            onSubmit: hookForm.handleSubmit(handleSubmit),
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": { width: "100%", maxWidth: "40rem" },
          },
        }}
      >
        <DialogTitle>Item Check List</DialogTitle>
        <DialogContent>
          <ModalLoading loading={saving}>
             <FormContainer title={selectedItemChecklist ? "Editar itens do check list" : "Cadastrar itens do check list"} arrangement="fullRow">
              <div className="flex flex-col gap-4">
                 <div className="w-full">
                  <DefaultFormInput name="codigo" label="Codigo" reactHookForm={hookForm} required={true} />
                 </div>
                  <div className="w-full">
                    <DefaultFormInput name="descricao" label="Descrição do Item" reactHookForm={hookForm} required={true} multiline={true} rows={4}/>
                  </div>
              </div>
             </FormContainer>
          </ModalLoading>
        </DialogContent>
          <DialogActions>
              <div className="w-full h-full items-center justify-between flex p-4 gap-4">
                <div>
                  {
                    isNotNullOrUndefined(selectedItemChecklist) &&
                    <PrimaryButton
                      buttonColor="yellow"
                      onClick={handleChangeHistory}>
                      <span className="text-xs">
                        Historico de alterações
                      </span>
                    </PrimaryButton>
                  }
                </div>
    
                <div className="flex flex-row gap-2">
                  <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                    <h1
                      className="text-sm text-black dark:text-white"
                      onClick={onClose}>
                      Cancelar
                    </h1>
                  </div>
    
                  <div className="w-[120px]">
                    {saving ? (
                      <PrimaryButton
                        buttonColor="primary-green">
                        Salvando...
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        type="submit"
                        buttonColor="primary-green">
                        Salvar
                      </PrimaryButton>
                    )}
                  </div>
                </div>
              </div>
          </DialogActions>
      </Dialog>
    </>
  );
};
